import { useEffect, useReducer } from 'react';
import { useExternalTokenAuth, useGetOrganization } from '@sib/api';
import { useUserSetupStore } from '@sib/auth';

export const useExternalToken = () => {
  const organizationId = useUserSetupStore(state => state.organization.id);
  const { data: organizationData } = useGetOrganization(organizationId);
  const [agentToken, setAgentToken] = useReducer(
    (_: string | null, nextToken: string | null) => nextToken,
    null
  );

  const { mutate: getAgentToken } = useExternalTokenAuth(
    organizationId,
    organizationData?.aiPort,
    {
      onSuccess: data => {
        const token = data?.access_token;
        if (token && typeof token === 'string') {
          setAgentToken(token);
        }
      },
    }
  );

  useEffect(() => {
    if (organizationId && organizationData?.aiEnabled) {
      setAgentToken(null);
      getAgentToken({ orgId: organizationId });
    }
  }, [organizationId, organizationData?.aiEnabled, getAgentToken]);

  return {
    agentToken,
    isAiEnabled: organizationData?.aiEnabled ?? false,
    organizationData,
  };
};
